const $win = $(window);

function activateZoom($sliderProduct) {
  if ($('.zoomContainer').length) {
    $('.zoomContainer').remove();
  };

  let zoomWidth = 552;
  let zoomHeight = 580;

  if ($win.width() <= 1379 && $win.width() >= 1200) {
    zoomWidth = 439;
    zoomHeight = 461;
  } else if ($win.width() <= 1199 && $win.width() >= 1024){
    zoomWidth = 380;
    zoomHeight = 399;
  } else if ($win.width() <= 1023 && $win.width() >= 768) {
    zoomWidth = 300;
    zoomHeight = 315;
  }

  $sliderProduct.find('.slick-active .section__image:not(.section__image--video) img').ezPlus({
    zoomType: 'window',
    zoomWindowWidth: zoomWidth,
    zoomWindowHeight: zoomHeight,
    borderSize: 0
  });
}

module.exports = {
  activateZoom
};



// WEBPACK FOOTER //
// ../assets/js/activate-zoom.js